module.exports = __webpack_public_path__ + "static/media/sign-in-bg-768.2906e83f.jpg";